module.exports = __webpack_public_path__ + "media/images/banners/banner-pattern2-45ca9b624bc7495010a95da58186d2c6.png";